import { useTranslation, Trans } from "react-i18next";

import el1 from '../../img/AboutUs/el1.png';
import el2 from '../../img/AboutUs/el2.png';
import robot from '../../img/AboutUs/robot.png';
import Button from "../Button";

import { Fade } from 'react-awesome-reveal';

function Main() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[40px] overflow-hidden">
        <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
            <div className="xl:h-[484px] bg-[#F1F1F1] w-full pt-[40px] px-[20px] xl:p-[80px] relative flex flex-col">
                <p className="text-[24px] xl:text-[36px] zen-dots leading-[1.2] text-[#1E1C21] xl:max-w-[600px]">{t('aboutus.1')}</p>
                <p className="text-[12px] xl:text-[14px] text-[#000000B2] ibm-plex xl:max-w-[393px] mt-[20px] xl:mt-[40px]">{t('aboutus.2')}</p>
                <Button className={'mt-[40px] mr-auto'}/>
                <img src={el2} className="absolute right-0 top-0 homemaintransition hidden xl:block" alt="" />
                <img src={el1} className="absolute bottom-0 right-0 homemaintransition2" alt="" />
                <Fade><img src={robot} className="xl:absolute bottom-0 right-0 mt-[40px] xl:mt-0 ml-auto mx-[-20px] xl:mx-0" alt="" /></Fade>         
            </div>
        </div>
    </div>
  );
}

export default Main;
